module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', {
    staticClass: "font-weight-bold darkgrey--text"
  }, [_c('div', [_vm._v("Tambah Nama Interpretasi")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('v-list-item', {
    staticClass: "pa-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-text-field', {
    staticStyle: {
      "font-weight": "500 !important"
    },
    attrs: {
      "outlined": "",
      "width": "500",
      "placeholder": "Nama Interpretasi"
    },
    model: {
      value: (_vm.data.name),
      callback: function($$v) {
        _vm.$set(_vm.data, "name", $$v)
      },
      expression: "data.name"
    }
  })], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-btn', {
    staticClass: "white--text ml-2",
    staticStyle: {
      "margin-top": "-30px"
    },
    attrs: {
      "color": "blew",
      "x-large": "",
      "depressed": "",
      "width": "60",
      "loading": _vm.isLoading,
      "disabled": !_vm.data.name
    },
    on: {
      "click": function($event) {
        return _vm.addPotentialIntelligences()
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.selectedRow.id ? "Edit" : "Tambah") + "\n                    ")])], 1), _vm._v(" "), _c('v-list-item-action', [(_vm.selectedRow.id) ? _c('v-btn', {
    staticStyle: {
      "margin-top": "-30px",
      "margin-left": "-10px"
    },
    attrs: {
      "x-large": "",
      "depressed": "",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.clearForm()
      }
    }
  }, [_vm._v("\n                        Batal\n                    ")]) : _vm._e()], 1)], 1)], 1)]), _vm._v(" "), _c('v-card-text', [_c('div', [_c('v-list', _vm._l((_vm.list_potential), function(data, i) {
    return _c('v-list-item', {
      key: i
    }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v("\n                            " + _vm._s(data.name) + "\n                        ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-btn', {
      attrs: {
        "fab": "",
        "depressed": "",
        "color": "red",
        "x-small": "",
        "dark": ""
      },
      on: {
        "click": function($event) {
          return _vm.confirmDeleteItem(data)
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-delete")])], 1)], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-btn', {
      staticStyle: {
        "margin-left": "-5px"
      },
      attrs: {
        "fab": "",
        "depressed": "",
        "color": "blew",
        "x-small": "",
        "dark": ""
      },
      on: {
        "click": function($event) {
          return _vm.detailItem(data)
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-pencil")])], 1)], 1)], 1)
  }), 1)], 1)]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pb-3"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "darkFade",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(" Tutup ")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "490px"
    },
    model: {
      value: (_vm.confirmDialog),
      callback: function($$v) {
        _vm.confirmDialog = $$v
      },
      expression: "confirmDialog"
    }
  }, [_c('v-card', {
    staticClass: "py-2"
  }, [_c('v-card-title', {
    staticStyle: {
      "word-break": "break-word !important"
    }
  }, [_vm._v("\n                Apakah anda akan menghapus nama interpretasi ini ?\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n                Nama interpretasi " + _vm._s(_vm.selectedRowDel.name) + " ini akan\n                dihapus.\n            ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "darkFade",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.confirmDialog = false
      }
    }
  }, [_vm._v("\n                    Batal\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red",
      "dark": "",
      "depressed": "",
      "loading": _vm.isLoadingForm
    },
    on: {
      "click": function($event) {
        return _vm.deleteItem()
      }
    }
  }, [_vm._v("\n                    Ok\n                ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0617ab79","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/ambis_test/components/DialogPotential.vue
// module id = 1480
// module chunks = 1